@if (storeMap) {
  <div>
    <bt-map #map [map]="storeMap" [zoom]="zoom" [size]="size" (load)="onMapLoad($event)" [canvasOptions]="{allowTouchScrolling: true}"></bt-map>
  </div>
}
